import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertTriangle, ArrowDown } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function ProblemSection() {
  const problems = ['Ganás la línea pero perdés la partida', 'Sos el primero en morir en las teamfights', 'No sabés qué hacer en mid y late game', 'Sentís que tus mecánicas no son el problema', 'No tenés control sobre los objetivos'];
  return <section className="py-20 bg-[#0d1117] relative overflow-hidden" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4" data-id="element-97">
        <div className="text-center mb-12" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-block p-3 rounded-full bg-red-500/10 mb-6" data-id="element-99">
            <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-100" />
          </motion.div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-101">
            ¿Te suena familiar?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-102">
            La mayoría de los ADC se estancan en el mismo Elo por años
            cometiendo los mismos errores una y otra vez.
          </p>
        </div>

        <div className="space-y-4 mb-16" data-id="element-103">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-[#161b22] p-6 rounded-xl border border-red-900/20 hover:border-red-500/30 transition-colors" data-id="element-104">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-105" />
              <span className="text-lg md:text-xl font-bold text-gray-200" data-id="element-106">
                {problem}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-red-900/10 border border-red-900/30 p-8 rounded-2xl text-center mb-12" data-id="element-107">
          <p className="text-xl text-gray-300 italic" data-id="element-108">
            "No es tu culpa. El rol de ADC es el más castigado del juego. Un
            error de posicionamiento y estás muerto. Pero hay una forma de jugar
            donde{' '}
            <span className="text-white font-bold" data-id="element-109">VOS tenés el control</span>."
          </p>
        </motion.div>

        <div className="flex justify-center" data-id="element-110">
          <CtaButton text="🔥 QUIERO DEJAR DE PERDER" subtext="IR A COMPRAR" className="w-full md:w-auto" href="#comprar" data-id="element-111" />
        </div>
      </div>
    </section>;
}